module.exports = __webpack_public_path__ + "static/media/explorer_108.645162f1.ico";